import { toZonedTime } from 'date-fns-tz';
import { format, parseISO } from 'date-fns';
import { getLocalTimeZone } from './getLocalTimeZone';

export const convertToLocalTimeZone = (isoDateTime, formatStr = null) => {
  const dateTime = parseISO(isoDateTime);
  const localDateTime = toZonedTime(dateTime, getLocalTimeZone());
  return formatStr ? format(localDateTime, formatStr) : localDateTime;
};
